export const FAVICON_LINK_KEYS = {
  icon: 'icon',
} as const

export type FaviconLinkKey = (typeof FAVICON_LINK_KEYS)[keyof typeof FAVICON_LINK_KEYS]
